<!-- From "spinkit" - credits to tobiasahlin.com -->
<template>
  <div class="spinner-mask" :class="{ global: !local, local, overlay }">
    <div class="spinner">
      <div class="rect1"></div>
      <div class="rect2"></div>
      <div class="rect3"></div>
      <div class="rect4"></div>
      <div class="rect5"></div>
    </div>
    <p v-if="text">
      {{ text }}<span v-for="dot in dots" :key="dot">.</span>
    </p>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dots: 1
    }
  },
  watch: {
    dots: function (val) {
      setTimeout(() => {
        this.dots = (this.dots + 1) % 4
      }, 500)
    }
  },
  mounted () {
    setTimeout(() => {
      this.dots = this.dots + 1
    }, 500)
  },
  props: {
    local: {
      type: Boolean,
      default: false
    },
    overlay: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      required: false
    }
  }
}
</script>

<style scoped lang="less">
@import '../styles/variables';
.overlay {
  background-color: rgba(255, 255, 255, 0.5);
  .spinner > div {
    background-color: @color-grey-darkest;
  }
}

.local {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.global {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  transition: opacity 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.spinner {
  width: 100px;
  height: 80px;
  text-align: center;
  font-size: 10px;
}

p {
  margin-top: 30px !important;
}

.spinner > div {
  background-color: white;
  height: 100%;
  width: 10px;
  display: inline-block;
  margin-right: 3px;
  box-shadow: @shadow;

  -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
  animation: sk-stretchdelay 1.2s infinite ease-in-out;
}

.spinner .rect2 {
  -webkit-animation-delay: -1.1s;
  animation-delay: -1.1s;
}

.spinner .rect3 {
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}

.spinner .rect4 {
  -webkit-animation-delay: -0.9s;
  animation-delay: -0.9s;
}

.spinner .rect5 {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
}

p {
  margin-top: 20px;
}

@-webkit-keyframes sk-stretchdelay {
  0%,
  40%,
  100% {
    -webkit-transform: scaleY(0.4);
  }
  20% {
    -webkit-transform: scaleY(1);
  }
}

@keyframes sk-stretchdelay {
  0%,
  40%,
  100% {
    transform: scaleY(0.4);
    -webkit-transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1);
    -webkit-transform: scaleY(1);
  }
}
</style>
